<div class="table-paginator">
  <div>{{ stats() }}</div>

  <div class="table-paginator__pages">
    <p-paginator
      (onPageChange)="handlePageChange($event)"
      [first]="first()"
      [rowsPerPageOptions]="[30, 60, 90, 200]"
      [rows]="rows()"
      [showJumpToPageInput]="true"
      [totalRecords]="total()" />
  </div>
</div>
